export default __webpack_public_path__ + "static/media/couple.c57239a8.svg";